const options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.3, 
};

const callback = (entries, observer) => {
  entries.forEach(entry => { 
    if (entry.isIntersecting && !entry.target.classList.contains("f-fade-in")) {
      entry.target.classList.add("f-fade-in");
      observer.unobserve(entry.target);
    } 
  })
}

const observer = new IntersectionObserver(callback, options);
const animatedElements = document.querySelectorAll(".animate");
animatedElements.forEach(element => observer.observe(element));





// {% comment %} js for radios to trigger variant change of grid card {% endcomment %}
// Use event delegation to handle dynamically added elements
document.addEventListener('change', function(event) {
    if (event.target.matches('.f-product-grid-item__option-radio')) {
        let productId = event.target.getAttribute('data-product-id');
        let optionsContainer = document.querySelector('.f-product-grid-item__options[data-product-id="' + productId + '"]');
        let label = event.target.closest('.f-product-grid-item__option-radio-label');
        
        optionsContainer.querySelectorAll('.f-product-grid-item__option-radio-label').forEach(function (lbl) {
            lbl.classList.remove('active');
        });
        
        if (label) {
            label.classList.add('active');
        }

        let variantInput = optionsContainer.querySelector('.variant-id-input');
        let variantsScript = document.getElementById('product_json_' + productId);
        let productJson = variantsScript ? JSON.parse(variantsScript.textContent) : [];

        let checkedInputs = []
        optionsContainer.querySelectorAll('input:checked').forEach(function (input) {
            checkedInputs.push(input.value + ' / ');
        })
        checkedInputs = checkedInputs.join('').slice(0, -3).trim();

        productJson.variants.forEach(function (variant) {
            if (variant.title == checkedInputs) {
                variantInput.value = variant.id;
                updateVariantData(optionsContainer.closest('.f-product-grid-item'), variant);
            }
        })
    }
});
 
document.addEventListener('click', function(event) {
    if (event.target.matches('.grid-choose-options')) {
        gridProductOptionsToggle(event.target);
    }
});
 
document.addEventListener('click', function(event) {
    if (event.target.matches('.f-product-grid-item__close')) {
        gridProductOptionsToggle(event.target);
    }
});

// Function to close the grid card options
function gridProductOptionsToggle(button) {
    let parentContainer = button.closest('.f-product-grid-item__details');
    let optionsContainer = parentContainer.querySelector('.f-product-grid-item__options');
    console.log(optionsContainer, parentContainer);
    if (optionsContainer) {
        optionsContainer.classList.toggle('active');
    }
}

// Function to initialize or reinitialize event listeners after fetch
function initializeProductGrid() { 
    console.log('Product grid initialized');
}

// Standalone function to update variant data
function updateVariantData(container, variant) {
    let variantPrice = container.querySelector('.f-product-grid-item__price--current');
    let variantSalePrice = container.querySelector('.f-product-grid-item__price--compare');
    let variantSaleBadge = container.querySelector('.f-product-grid-item__badge--sale')
    
    if (variantPrice) {
        variantPrice.textContent = Shopify.formatMoney(variant.price, Shopify.money_format);
    }
    
    if (variantSalePrice) {
        if (variant.compare_at_price > variant.price) {
            variantSalePrice.textContent = Shopify.formatMoney(variant.compare_at_price, Shopify.money_format);
        } else {
            variantSalePrice.textContent = '';
            variantSaleBadge.setAttribute('style', 'display: none;');
        }
    }

    let variantAvailable = container.querySelector('.btn.add-to-cart');
    if (variantAvailable) {
        if (variant.available) {
            variantAvailable.classList.remove('disabled');
            variantAvailable.removeAttribute('disabled');
            variantAvailable.textContent = 'Add to cart';
        } else {
            variantAvailable.classList.add('disabled');
            variantAvailable.setAttribute('disabled', 'disabled');
            variantAvailable.textContent = 'Sold Out';
        }
    }
}

// Optional: Call this after your fetch requests complete
// Example usage after fetch:
/*
fetch('/your-endpoint')
    .then(response => response.text())
    .then(html => {
        // Update your DOM with new content
        document.querySelector('#product-grid').innerHTML = html;
        // Initialize the product grid (optional since we use event delegation)
        initializeProductGrid();
    });
*/





/*
 * FORMAT MONEY
 * Formats the passed value as money with currency symbol.
 * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 */
var Shopify = Shopify || {};
Shopify.money_format = document.querySelector('#money_format').value;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
